export default __webpack_public_path__ + "static/media/ru_RU.7c0c742e.svg";